import React from "react";
import { Fade, Box } from "@material-ui/core";

function FadeContainer(props) {
  const style = {};
  if (props.backgroundColor) {
    style.backgroundColor = props.backgroundColor;
  }
  return (
    <Fade
      in={props.open}
      mountOnEnter
      unmountOnExit
      timeout={{ enter: 225, exit: 0 }}
    >
      <Box
        width="100%"
        height="100%"
        position="relative"
        style={style}
        display="flex"
        flexDirection="column"
      >
        {props.children}
      </Box>
    </Fade>
  );
}

export default FadeContainer;
